<template>

    <Page>
        <div class="grid grid-cols-2 justify-center">
            <Image src="/PointOfSale/protect-brochure.png" floor-shadow />
            <Image src="/PointOfSale/protect-pullup-banner.png" class="scale-[125%]" floor-shadow />
        </div>
    </Page>

</template>